<template>
  <div class="taskContainer">
    <el-container style="height: 100%;">
      <el-container style="margin-top: 10px;">
      <el-aside width="192px" class="aside">
        <slot name="aside"></slot>
      </el-aside>
      <el-container>
        <!-- <el-header height="30px">
          asdfas
        </el-header> -->
        <el-main>
          <slot name="main"></slot>
        </el-main>
        <!-- <el-footer class="footer">
          <slot name="footer"></slot>
        </el-footer> -->
      </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import templateTag from "@/components/MainLayout/template/templateTag.vue";
export default {
  data() {
    return {
      searchText: ""
    };
  },
  components: {
    templateTag
  },
  computed: {
    // searchCondition: function() {
    //   return this.$store.state.task.searchCondition;
    // }
  },
  watch: {
    // searchText(newSearchText, oldSearchText) {
    //   this.debouncedSearch();
    // }
  },
  created() {
    // this.debouncedSearch = _.debounce(this.getSearch, 500);
  },
  methods: {
    getSearch() {
      console.log("快速查询功能");
    }
  }
};
</script>

<style lang="scss" scoped>
.taskContainer {
  height: 100%;
  .header {
    padding: 0;
    background: white;
  }
  .aside{
    background: white;
    // border-right: 1px solid #000;
  }
  .el-main{
    padding: 0px 0px 0px 10px;
  }
  .el-tabs{
    background: white;
  }
  .footer{
    line-height: 50px;
    padding: 0px 0px 0px 10px;
  }
}
</style>
<style lang="scss">
.taskContainer {
  .el-tabs{
    background: white;
    height: 100%;
  }
  .el-tabs__header{
    margin: 0;
  }
}
</style>
